import {
  Card,
  CardContent,
  Typography,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  CardActionArea,
  Avatar,
} from "@mui/material";
import React from "react";
import "./membership_renewal.css";

const MembershipRenewal = () => {
  return (
    <div className="membership-renewal">
      {/*My Membership */}
      <div className="mb-4">
        <div className="membership-info-label">
          <span>Membership Information</span>
        </div>
        <div className="membership-info-row mt-2">
          <Card sx={{ minWidth: "auto" }} className="d-flex membership-info">
            <CardContent sx={{ width: "100%" }}>
              <div className="mi-container">
                <span className="mi-label">Email:</span>
                <span className="mi-label">xxx@gmail.com</span>
              </div>
              <div className="mi-container">
                <span className="mi-label">Name:</span>
                <span className="mi-label">XxX</span>
              </div>
              <div className="mi-container">
                <span className="mi-label">Company Name:</span>
                <span className="mi-label">XxXx</span>
              </div>
              <div className="mi-container">
                <span className="mi-label">Member ID:</span>
                <span className="mi-label">XxXx-0000-asd-1212</span>
              </div>
              <div className="mi-container">
                <span className="mi-label">Membership Type:</span>
                <span className="mi-label">Corporate Member</span>
              </div>
              <div className="mi-container">
                <span className="mi-label">Account Type:</span>
                <span className="mi-label">Appointed</span>
              </div>
              <div className="mi-container">
                <span className="mi-label">Subscription:</span>
                <span className="mi-label">Annual Subscription</span>
              </div>
              <div className="mi-container">
                <span className="mi-label">Validity:</span>
                <span className="mi-label">1 Jan 2024 - 31 Dec 2024</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default MembershipRenewal;
